import { render, staticRenderFns } from "./FieldLabelNormal.vue?vue&type=template&id=49243f2a&scoped=true&"
import script from "./FieldLabelNormal.vue?vue&type=script&lang=js&"
export * from "./FieldLabelNormal.vue?vue&type=script&lang=js&"
import style0 from "./FieldLabelNormal.vue?vue&type=style&index=0&id=49243f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49243f2a",
  null
  
)

export default component.exports